import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.el.addEventListener( 'submit', this.onSubmit.bind( this ) );
    }

    onSubmit( ev ) {
        ev.preventDefault();
        this.el.classList.remove( 'loading' );
        this.email = this.el.querySelector( '[name="user_email"]');
        this.subject = this.el.querySelector( '[name="subject"]');
        this.body = this.el.querySelector( '[name="message"]');
        window.location.href = `mailto:${this.email.value}?subject=${this.subject.value}&body=${this.body.value}`;


    }

    init() {}
    destroy(){}
}
